import { BrowserRouter as Router } from 'react-router-dom';

import AppRouter from './routes/AppRouter';
import { StoreProvider } from './store/store';

function App() {
  return (
    <StoreProvider>
      <Router>
        <div>
          <AppRouter />
        </div>
      </Router>
    </StoreProvider>
  );
}

export default App;
